import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { ObjectBuilderComponent } from './ObjectBuilderComponent';

export const ObjectBuilder: React.FC = () => {
  const [searchParams] = useSearchParams();
  return <ObjectBuilderComponent initialObjectId={searchParams.get('edit')} />;
};
